// Desliza hacia abajo (muestra) con transición de altura/márgenes/padding.
export function slideDown(elm: HTMLElement, duration = 300): Promise<void> {
  if (elm.classList.contains("transitioning")) return Promise.resolve();

  return new Promise<void>((resolve) => {
    elm.classList.add("transitioning");

    // Restituye display si estaba oculto
    elm.style.removeProperty("display");
    let display = window.getComputedStyle(elm).display;
    if (display === "none") display = "block";
    elm.style.display = display;

    const height = elm.offsetHeight; // Altura objetivo

    // Estado inicial “colapsado”
    elm.style.overflow = "hidden";
    elm.style.height = "0";
    elm.style.paddingTop = "0";
    elm.style.paddingBottom = "0";
    elm.style.marginTop = "0";
    elm.style.marginBottom = "0";

    // Fuerza reflow
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    elm.offsetHeight;

    // Transición hacia la altura real
    elm.style.boxSizing = "border-box";
    elm.style.transitionProperty = "height, margin, padding";
    elm.style.transitionDuration = `${duration}ms`;
    elm.style.height = `${height}px`;

    // Quitamos paddings/márgenes para que el navegador los interpole
    elm.style.removeProperty("padding-top");
    elm.style.removeProperty("padding-bottom");
    elm.style.removeProperty("margin-top");
    elm.style.removeProperty("margin-bottom");

    const done = () => {
      elm.style.removeProperty("height");
      elm.style.removeProperty("overflow");
      elm.style.removeProperty("transition-duration");
      elm.style.removeProperty("transition-property");
      elm.classList.remove("transitioning");
      elm.removeEventListener("transitionend", onEnd);
      resolve();
    };

    const onEnd = (e: TransitionEvent) => {
      if (e.target === elm && e.propertyName === "height") done();
    };

    elm.addEventListener("transitionend", onEnd, { once: true });
    window.setTimeout(done, duration + 50);
  });
}
